import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideStore, provideState } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { ContactpersonModule } from './contactperson/contactperson.module';
import { CustomerModule } from './customer/customer.module';
import { EmployeeModule } from './employee/employee.module';
import { SharedModule } from './shared/shared.module';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    CustomerModule,
    ContactpersonModule,
    EmployeeModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),
    provideState('app', appReducer),
    provideEffects([AppEffects]),
  ],
})
export class AppModule {}
